<template>
  <div v-bind:class="getClassName" class="card feature-card">
    <div class="card-icon-container">
      <div class="card-icon-bck">
        <div class="card-icon"></div>
      </div>
    </div>
    <span class="card-label">{{label}}</span>
  </div>
</template>
<script>
export default {
  name: 'home-card',
  props: ['label'],
  data() {
    return {};
  },
  computed: {
    getClassName() {
      return (
        'feature-card-' + this.label.replace(/[^a-zA-Z ]/g, '').toLowerCase()
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.card {
  width: 118px;
  min-width: 118px;
  height: 126px;
  border-radius: $default-border-radius;
  .card-icon-container {
    margin: 20px 14px 0 14px;
  }
  .card-icon-bck {
    width: 52px;
    height: 52px;
    border-radius: 50%;
  }
  .card-icon {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: 50%;
  }
}
@each $label, $config in $cards-colors {
  $icon: map-get($config, 'icon');

  .feature-card-#{$label} {
    // background-color: map-get($config, "background-color");
    background-image: url(map-get($config, 'background-image'));
    background-size: contain;
    // .card-icon-bck {
    //   @if not map-has-key($config, 'icon-full') {
    //     background-color: #ffffff;
    //     opacity: 0.5;
    //   }
    // }
    // .card-icon {
    //   background-image: url('#{$icon}');
    // }
  }
}
.card-label {
  font-weight: 500;
  // font-size: 1.063em;
  font-size: 0.95em;
  color: #ffffff;
  margin-left: 14px;
  margin-top: 13px;
  display: inline-block;
  letter-spacing: 1px;
}
</style>
